import { createAction, props } from '@ngrx/store';

const GET_APP_CONFIG_KEYS = '[AppConfigKeys] Get AppConfigKeys';
const SAVE_APP_CONFIG_KEYS = '[AppConfigKeys] Save AppConfigKeys';
const SET_APP_CONFIG_KEYS = '[AppConfigKeys] Set AppConfigKeys';
const SET_ENVIRONMENTS = '[Environments] Set environments';
const DELETE_APP_CONFIG_KEYS = '[AppConfigKeys] Delete AppConfigKeys';

const getAppConfigKeys = createAction(
  GET_APP_CONFIG_KEYS,
  props<{ apiConstants: any; appId: any; searchFields: any }>()
);

const saveAppConfigKeys = createAction(
  SAVE_APP_CONFIG_KEYS,
  props<{ saveapiConstants: any; appconfigkeysData: any }>()
);

const setAppConfigKeys = createAction(SET_APP_CONFIG_KEYS, props<{ appconfigkeysTable: any }>());

const setEnvironments = createAction(SET_ENVIRONMENTS, props<{ environmentsTable: any }>());

const deleteAppConfigKeys = createAction(
  DELETE_APP_CONFIG_KEYS,
  props<{ deleteApiConstants: any; appconfigkeysId: any }>()
);

export { getAppConfigKeys, saveAppConfigKeys, setAppConfigKeys, deleteAppConfigKeys, setEnvironments };
